export const PAYMENT_LIST = "payment_list"; 
export const PAYMENT_LIST_SUCCESSFULL = "payment_list_successfull";
export const BILLS_NO_LIST = "bill_no_list";
export const BILLS_NO_LIST_SUCCESSFULL = "bill_no_list_successfull";
export const PAYMENT_CREATE = 'payment_create';
export const PAYMENT_CREATE_SUCCESSFULL = 'payment_create_successfull';